/* ------------------------------Toggle password -------------------------------*/
document.addEventListener("click", function (event) {
  // Check if the clicked element is the 'eyeIcon'
  if (event.target.classList.contains("newFieldIcon-passwordEye")) {
    // Toggle the eye icon state
    event.target.classList.toggle("fa-eye");
    event.target.classList.toggle("fa-eye-slash");
    event.target.classList.toggle("showPassword");

    // Find the input element associated with this icon using the `toggle` attribute
    const inputSelector = event.target.getAttribute("toggle");
    if (inputSelector) {
      const input = document.querySelector(inputSelector);

      if (input) {
        // Toggle the input type between 'password' and 'text'
        input.type = input.type === "password" ? "text" : "password";
      }
    }
  }
});
document.addEventListener("DOMContentLoaded", function () {
  const currentURL = window.location.href;
  const pageTitle = document.title;

  const shareButton = document.querySelector(".shareButton.main");
  const shareGroup = document.querySelector(".groupButton2");

  if (shareButton && shareGroup) {
    shareButton.addEventListener("click", function () {
      shareGroup.classList.toggle("active");
    });

    document.addEventListener("click", function (e) {
      if (!shareButton.contains(e.target) && !shareGroup.contains(e.target)) {
        shareGroup.classList.remove("active");
      }
    });
  }

  const shareButtons = document.querySelectorAll(".social-button");
  shareButtons.forEach((button) => {
    button.addEventListener("click", function () {
      const platform = button.getAttribute("data-platform");

      let shareURL = "";
      switch (platform) {
        case "facebook":
          shareURL = `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(currentURL)}`;
          break;
        case "twitter":
          shareURL = `https://twitter.com/intent/tweet?url=${encodeURIComponent(currentURL)}&text=${encodeURIComponent(pageTitle)}`;
          break;
        case "linkedin":
          shareURL = `https://www.linkedin.com/sharing/share-offsite/?url=${encodeURIComponent(currentURL)}`;
          break;
        case "pinterest":
          shareURL = `https://pinterest.com/pin/create/button/?url=${encodeURIComponent(currentURL)}&description=${encodeURIComponent(pageTitle)}`;
          break;
        case "whatsapp":
          shareURL = `https://wa.me/?text=${encodeURIComponent(pageTitle + " " + currentURL)}`;
          break;
        case "email":
          shareURL = `mailto:?subject=${encodeURIComponent(pageTitle)}&body=${encodeURIComponent(currentURL)}`;
          break;
        case "copy":
          navigator.clipboard.writeText(currentURL);
          return;
      }

      if (shareURL) {
        window.open(shareURL, "_blank", "noopener,noreferrer");
      }
    });
  });
});



// -------------------------------------------Register page D.O.B-------------------------------------------------
document.addEventListener("DOMContentLoaded", function () {
  const dayDropdown = document.getElementById("select-day");
  const monthDropdown = document.getElementById("select-month");
  const yearDropdown = document.getElementById("select-year");

  if (!dayDropdown || !monthDropdown || !yearDropdown) {
    console.error("Dropdown elements not found!");
    return;
  }

  for (let day = 1; day <= 31; day++) {
    let option = document.createElement("option");
    option.value = day;
    option.textContent = day;
    dayDropdown.appendChild(option);
  }

  const months = [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December",
  ];

  months.forEach((month, index) => {
    let option = document.createElement("option");
    option.value = index + 1;
    option.textContent = month;
    monthDropdown.appendChild(option);
  });

  const currentYear = new Date().getFullYear();
  const startYear = 1920;

  for (let year = currentYear; year >= startYear; year--) {
    let option = document.createElement("option");
    option.value = year;
    option.textContent = year;
    yearDropdown.appendChild(option);
  }
});

/* --------------------------------------------------- END ----------------------------------------------------*/

// Account mobile nav
if (window.innerWidth <= 750) {
  const navTrigger = document.getElementById("navTrigger");
  const navList = document.querySelector(".profile-navigation");

  navList?.classList.add("hidden");

  navTrigger?.addEventListener("click", function () {
    navList.classList.toggle("hidden");
    navTrigger.classList.toggle("navTriggerActive");
  });

  const navListItems = document.querySelectorAll(".profile-navigation li a");
  navListItems?.forEach((item) => {
    item.addEventListener("click", function (event) {
      event.preventDefault();
      const content = this.innerHTML;
      navTrigger.innerHTML = content; // Update innerHTML of navTrigger
      navList.classList.add("hidden");
      navTrigger.classList.toggle("navTriggerActive");
    });
  });
}

// ----------------------  accordion on Collection page --------------
if (window.location.href.includes('/collection')) {
  document.addEventListener('DOMContentLoaded', function () {
    const triggers = document.querySelectorAll('.collection-hero__description .returnAccord-block_triggr');
    triggers.forEach(function (trigger) {
      trigger.addEventListener('click', function (e) {
        e.preventDefault();
        const content = this.nextElementSibling;
        if (content.classList.contains('show')) {
          content.classList.remove('show');
          this.classList.add('collapsed');
        } else {
          content.classList.add('show');
          this.classList.remove('collapsed');
        }
      });
    });
  });
}

// Custom js for Coupan code Discount App
document.addEventListener('DOMContentLoaded', () => {
  const TARGET_CONTAINER_SELECTOR = '.scDiscount__container'; // the parent container to observe

  // Initialize all functionality (accordion, copy buttons, etc.)
  function initializeDiscountUI() {
    console.log('Initializing discount UI...');

    const accordionBtn = document.querySelector('.coupan-container .accordion-button');
    const scDiscount__container = document.querySelector('.scDiscount__container');
    const available_discounts = document.querySelector('.available-discounts');
    const sc_simple_info_tag = document.querySelector(".sc_simple-info__tag button");

    // Accordion Toggle
    if (accordionBtn && scDiscount__container && available_discounts) {
      accordionBtn.addEventListener("click", function () {
        const isVisible = window.getComputedStyle(scDiscount__container).display !== "none";

        if (!isVisible) {
          scDiscount__container.style.display = "block";
          scDiscount__container.classList.remove("open");
          available_discounts.style.display = "block";
          available_discounts.classList.remove("open");
        } else {
          scDiscount__container.style.display = "block";
          scDiscount__container.classList.add("open");
          available_discounts.style.display = "block";
          available_discounts.classList.add("open");
        }

        console.log("Toggled accordion to", scDiscount__container.style.display);
      });
    }

    // Optional tag logger
    sc_simple_info_tag?.addEventListener("click", () => {
      console.log("sc_simple_info_tag clicked");
    });

    // Copy Button Logic
    const copyButtons = document.querySelectorAll('.copy-btn');
    copyButtons.forEach(button => {
      button?.addEventListener('click', function () {
        const code = button.getAttribute('data-code');
        if (!code) return;

        console.log("Copied code:", code);

        navigator.clipboard.writeText(code)
          .then(() => {
            // 🔁 Get fresh input and button references
            const discount_input = document.querySelector('.sc-cube-text.sc-cube-code');
            const applyDiscountBtn = document.querySelector('#sc-discount__submit');

            if (!discount_input || !applyDiscountBtn) {
              console.warn("Discount input or button not found.");
              return;
            }

            // Set value and simulate real input
            discount_input.value = code;
            discount_input.dispatchEvent(new Event('input', { bubbles: true }));
            discount_input.dispatchEvent(new Event('change', { bubbles: true }));
            discount_input.dispatchEvent(new KeyboardEvent('keydown', {
              bubbles: true,
              key: 'A',
              code: 'KeyA',
            }));

            // Click after small delay
            setTimeout(() => {
              applyDiscountBtn.dispatchEvent(new MouseEvent('click', { bubbles: true }));
            }, 100);

            // UI feedback
            button.textContent = 'Kopieret!';
            setTimeout(() => {
              button.textContent = 'Kopiér';
            }, 1500);
          })
          .catch(err => {
            console.error('Clipboard copy failed:', err);
          });
      });
    });
  }

  // Observe for DOM changes from 3rd-party app
  const observer = new MutationObserver((mutationsList) => {
    for (const mutation of mutationsList) {
      if (mutation.type === 'childList' || mutation.type === 'subtree') {
        // Re-initialize UI after DOM change
        initializeDiscountUI();
      }
    }
  });

  // Start observing the document body (or a more specific parent if you know it)
  const target = document.body;
  observer.observe(target, {
    childList: true,
    subtree: true
  });

  // Initial call in case the UI is already loaded
  initializeDiscountUI();
});


// Badge Animation - Alternate Between Two Texts
class BadgeAnimation extends HTMLElement {
  constructor() {
    super();
    this.toggleState = false;
    this.interval = null;
  }

  connectedCallback() {
    // Find span inside the element
    this.badge = this
    if (!this.badge) return;

    this.badge1 = this.getAttribute('data-badge1') || "";
    this.badge2 = this.getAttribute('data-badge2') || "";

    // Initial text
    this.badge.textContent = this.badge1;

    // Start animation loop
    this.interval = setInterval(() => this.updateText(), 1500);
  }

  updateText() {
    const textNode = Array.from(this.badge.childNodes).find(
      n => n.nodeType === Node.TEXT_NODE && n.textContent.trim() !== ""
    );

    if (!textNode) return;

    // Fade out
    this.badge.classList.add('badge-fade-out');

    // Swap text
    setTimeout(() => {
      textNode.textContent = this.toggleState ? this.badge1 : this.badge2;
      this.badge.classList.remove('badge-fade-out');
      this.toggleState = !this.toggleState;
    }, 100); // match CSS duration
  }

  disconnectedCallback() {
    clearInterval(this.interval);
  }
}

customElements.define('badge-animation', BadgeAnimation);
